// extracted by mini-css-extract-plugin
export default {"zoomModal":"k3-z","image":"l3-z","button":"m3-z","isOverlayShown":"n3-z"};